import { __makeTemplateObject } from "tslib";
import themeGet from '@styled-system/theme-get';
import { border, color, layout, shadow, space } from 'styled-system';
import styled from '@marvelapp/styled';
export var CardElement = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  position: relative;\n  transition: all 400ms ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  position: relative;\n  transition: all 400ms ", ";\n"])), border, color, layout, shadow, space, themeGet('easings.smooth.string'));
var templateObject_1;
